import { connect } from "react-redux";
import actionCreators from "../../redux/actionCreators";
import { getObjects, getSelectedMethods } from "../../redux/selectors";
import MethodsBottomPanel from "./methodsBottomPanel";
const mapStateToProps = (state) => ({
    selectedMethods: getSelectedMethods(state),
    documentObjects: getObjects(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getObjects()),
    onClear: () => {
        dispatch(actionCreators.setShowScriptEditorPanel(false));
        dispatch(actionCreators.clearMethodsSelected());
    },
    onSetShowScriptEditorPanel: (show, data, targetSelector) => dispatch(actionCreators.setShowScriptEditorPanel(show, data, targetSelector))
});
export default connect(mapStateToProps, mapDispatchToProps)(MethodsBottomPanel);
